module.exports = __webpack_public_path__ + "static/media/auth0-create-tenant-step5.c00a5e5c.png";